import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Paper, Skeleton } from "@mui/material";
import { DocumentList, ExpGroup, PageHeader, StepActions, TabBofuV2 } from "@components/ui_v2";
import { RootState, useAppDispatch } from "@store/store";
import { setBofuTabDictamenDocument } from "@store/slices/bofuSlice";
import { validateRequiredDocumentsAreUploaded } from "@components/TabBofu/functions";
import { PATHS_EXPEDIENTE_V2 } from "@helpers/constantes";

export const ExpDictamen = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const bofuTabs = useSelector((state: RootState) => state.bofu.bofu_tabs_obj);
  const bofuLoading = useSelector((state: RootState) => state.bofu.isLoading);

  const onNext = () => navigate(PATHS_EXPEDIENTE_V2.informacionSolicitud.path);

  const documentos = bofuTabs?.dictamen?.documents || [];

  return (
    <Box>
      <PageHeader
        eyebrow="Expediente · Dictamen jurídico"
        title="Validemos la estructura legal de tu empresa"
        subtitle="Iniciaremos el proceso con tus actas para validar la constitución, la representación legal y los cambios estructurales relevantes."
      />

      <TabBofuV2 active="dictamen" />

      {bofuLoading ? (
        <Skeleton variant="rectangular" animation="wave" sx={{ height: 220, borderRadius: "12px" }} />
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "22px" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <ExpGroup num="A" title="Documentos legales" />
            <Paper variant="lendia_paper" sx={{ p: "20px 22px" }}>
              <DocumentList
                documents={documentos}
                onChange={({ document, newValue }) =>
                  dispatch(
                    setBofuTabDictamenDocument({ document, newValue, valueAction: undefined, valueIndex: undefined }),
                  )
                }
                onChangeMultiple={({ document, newValue, valueAction, valueIndex }) =>
                  dispatch(setBofuTabDictamenDocument({ document, newValue, valueAction, valueIndex }))
                }
              />
            </Paper>
          </Box>

          <StepActions
            onNext={onNext}
            nextDisabled={bofuLoading || !validateRequiredDocumentsAreUploaded(documentos)}
            nextTestId="expediente-dictamen-continue-button"
          />
        </Box>
      )}
    </Box>
  );
};
